import React from 'react'

const About = () => {
  const features = [
    {
      icon: "🌿",
      title: "Natural Remedies",
      description: "We use only natural herbs and traditional Ayurvedic medicines to heal and restore balance."
    },
    {
      icon: "🧘‍♀️",
      title: "Holistic Approach",
      description: "Our treatments address the root cause, focusing on mind, body, and spirit harmony."
    },
    {
      icon: "👨‍⚕️",
      title: "Expert Practitioners",
      description: "Our team consists of certified Ayurvedic doctors with years of experience."
    },
    {
      icon: "🎯",
      title: "Personalized Care",
      description: "Each treatment plan is customized based on your unique constitution and health needs."
    }
  ]

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose <span className="text-green-600">Sravani</span> <span className="text-brown-600">Ayurdham</span>?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We combine ancient Ayurvedic wisdom with modern understanding to provide comprehensive, 
            natural healthcare solutions that promote lasting wellness and vitality.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {features.map((feature, index) => (
            <div key={index} className="text-center p-6 rounded-xl hover:shadow-lg transition-shadow duration-300">
              <div className="text-4xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* About Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Our <span className="text-green-600">Mission</span> & <span className="text-brown-600">Vision</span>
            </h3>
            <div className="space-y-6">
              <div className="border-l-4 border-green-500 pl-6">
                <h4 className="text-xl font-semibold text-gray-900 mb-2">Mission</h4>
                <p className="text-gray-600">
                  To provide authentic Ayurvedic treatments that promote natural healing, 
                  prevent disease, and enhance the overall quality of life for our patients 
                  through personalized, holistic care.
                </p>
              </div>
              <div className="border-l-4 border-brown-500 pl-6">
                <h4 className="text-xl font-semibold text-gray-900 mb-2">Vision</h4>
                <p className="text-gray-600">
                  To be the leading center for Ayurvedic wellness, bridging ancient wisdom 
                  with modern healthcare needs, and making natural healing accessible to everyone 
                  seeking a balanced and healthy lifestyle.
                </p>
              </div>
            </div>
          </div>

          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80"
              alt="Ayurvedic clinic interior"
              className="rounded-xl shadow-xl"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-green-500/20 to-brown-500/20 rounded-xl"></div>
          </div>
        </div>

        {/* Statistics */}
        <div className="mt-20 bg-gradient-to-r from-green-50 to-brown-50 rounded-2xl p-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-green-600 mb-2">500+</div>
              <div className="text-gray-700">Patients Treated</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-brown-600 mb-2">15+</div>
              <div className="text-gray-700">Years of Experience</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-green-600 mb-2">50+</div>
              <div className="text-gray-700">Treatment Types</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-brown-600 mb-2">98%</div>
              <div className="text-gray-700">Success Rate</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
